export const getters = {
    getAtividadePosVenda: state => state.atividadePosVenda,
    getAtividadesPosVenda: state => state.atividadesPosVenda,
    getModalCadastroAtividadePosVenda: state => state.modalCadastroAtividadePosVenda,
    getModalExcluirAtividadePosVenda: state => state.modalExcluirAtividadePosVenda,
    getModalPesquisarAtividadePosVenda: state => state.modalPesquisarAtividadePosVenda,
}

export default {}